<template>
  <el-dialog :title="auditInfo.title" :visible.sync="auditInfo.showDia" v-if="auditInfo.showDia"
    :close-on-click-modal="false">
    <el-form :model="ruleForm" size="small" ref="rForm" label-width="100px" class="ruleForm" :rules="rules">
      <el-form-item label="审核意见：" prop="myAuditStatus">
        <el-radio-group v-model="ruleForm.myAuditStatus" @change="auditScheduleChange">
          <el-radio v-for="(item, i) in auditScheduleAttr" :key="i" :label="item.paramKey">
            {{ item.paramValue }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="驳回原因：" v-if="ruleForm.myAuditStatus == 0" prop="auditContent">
        <el-input type="textarea" :row="3" placeholder="请输入驳回原因" maxlength="200" show-word-limit
          v-model="ruleForm.auditContent"></el-input>
      </el-form-item>
      <!-- 
      <el-form-item v-if="ruleForm.myAuditStatus == 1">
        
      </el-form-item> -->

      <el-form-item v-if="ruleForm.myAuditStatus == 1" prop="auditAttachment" label="单位证明：">

        <!-- <a  @cl> -->
        <butn btntype="primary" @click="downloadFile(EXCP)" title="下载模板"></butn>
        <!-- </a> -->

        <upload :limit="1" class="upload_file" :path="'user/modify_mobile_audit/attachment'"
          v-model="ruleForm.auditAttachment" ref="removeFile" :accepts='["pdf", "jpg", "jpeg", "png"]' />
      </el-form-item>

      <el-form-item label="审核人：" v-if="ruleForm.myAuditStatus == 1" prop="auditUserIdList">

        <el-input style="width: 80%" placeholder="请选择审核人" v-model="names" readonly></el-input>
        <el-button class="button-dept" @click="selectAuditor">选择</el-button>
      </el-form-item>
      <el-form-item label="短信通知：" v-if="ruleForm.myAuditStatus == 1" prop="isSendSms">
        <el-radio v-model="ruleForm.isSendSms" label="1">是</el-radio>
        <el-radio v-model="ruleForm.isSendSms" label="0">否</el-radio>
      </el-form-item>
      <!-- <el-form-item label="发送对象：" v-if="ruleForm.isSendSms == 1 && ruleForm.myAuditStatus == 1">
        {{ rowData.userName }}
      </el-form-item> -->
      <el-form-item label="消息内容：" v-if="ruleForm.isSendSms == 1 && ruleForm.myAuditStatus == 1">
        <el-input type="textarea" :row="3" disabled v-model="auditContent"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="updateForm" title="确定"></butn>
    </div>

  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { submitModifyMobileAudit } from "@/api/user";
import { getDataMap } from "@/api/sysParam";
import Upload from "@/components/upload/index";
import Bus from "./Bus.js";
import { userAuditorList } from "@/api/user";
import { downloadByUrl } from "@/utils/common.js";
import {
  tempModifyMobileTemplate,
} from "@/assets/excel/index.js";

export default {
  name: 'auditor',
  components: { butn, Upload },
  props: ["auditInfo"],
  data() {
    return {
      size: "small",
      ruleForm: {
        auditContent: '',
        myAuditStatus: '1',
        isSendSms: '1',
        auditUserIdList: [],
        auditAttachment: []
      },
      showMan: false,
      auditScheduleAttr: [
        {
          "paramKey": "1",
          "paramValue": "同意"
        },
        {
          "paramKey": "0",
          "paramValue": "不同意"
        },

      ],
      memberList: [],
      rules: {
        myAuditStatus: [{ required: true, message: "请选择审核意见" }],
        auditUserId: [{ required: true, message: "请选择审核人" }],
        isSendSms: [{ required: true, message: "请选择短信通知" }],
        auditContent: [

          { required: true, message: '请输入驳回原因', trigger: 'blur' },
        ],

        auditAttachment: [
          { required: true, message: "请上传附件", trigger: "" },
        ],
        auditUserIdList: [
          { type: 'array', required: true, message: '请至少选择一个审核人', trigger: 'change' }
        ],

      },

      EXCP: tempModifyMobileTemplate,
      rowData: {}
    };
  },
  methods: {
    selectAuditor() {
      Bus.$emit("selectAuditor", this.deptId);
    },
    downloadFile(url) {
      downloadByUrl(null, url);
    },
    handleChange() { },
    auditScheduleChange(val) {
      // this.showMan = val == 3;
    },
    closeFrom() {
      this.$emit("closeDia", 0, 0);
    },
    updateForm() {
      this.$refs["rForm"].validate((valid) => {
        if (valid) {
          if (this.ruleForm.myAuditStatus == 0 && !this.ruleForm.auditContent) {
            this.$message.warning('请输入驳回原因!!');
            return
          }

          const { query } = this.$route
          let row = JSON.parse(query.row)
          let params = {
            ...this.ruleForm,
            auditAttachment: JSON.stringify(this.ruleForm.auditAttachment),
            auditUserIdList: (this.ruleForm.auditUserIdList || []).map(e => e.uuid),
            smsContent: this.auditContent,
            step: 2,
            userAuditUuid: row.userAuditUuid
          };
          if (params.myAuditStatus == 0) {
            params.isSendSms = 0
            delete params.smsContent
          }
          console.log('params', params)
          submitModifyMobileAudit(params).then((res) => {
            if (res.code === 0) {

              this.$message.success(res.msg);

              this.$emit("closeDia", 0, 1);
            }
          });
        }
      });
    },
  },
  computed: {
    names() {

      return (this.ruleForm.auditUserIdList || []).map(e => e.userName).join(',')
    },
    auditContent() {
      let s = ''
      let v = this.ruleForm.myAuditStatus

      if (v == 0) {
        s = `您好，您提交的修改手机号申请审核不通过。原因：${this.ruleForm.auditContent ? this.ruleForm.auditContent : ''}`
      }
      if (v == 1) {
        const { query } = this.$route
        let row = JSON.parse(query.row)
        s = `您好，${row.userName}（${row.unitPosition}）提交了修改手机号申请，请登录浙里学习“管理后台-修改手机号审核”模块进行审核。`
      }
      return s
    }
  },
  watch: {
    'auditInfo.showDia'(v, oV) {
      if (v) {
        this.ruleForm = {
          auditContent: '',
          myAuditStatus: '1',
          isSendSms: '1',
          auditUserIdList: []
        }
      }
    },
    // 'auditInfo.showDia'(v, oV){
    //     if(v){
    //       this.
    //     }
    // },

  },
  created() {
    let v = this.$route.query?.row || {}
    this.rowData = JSON.parse(v)
    Bus.$on("didSelectAuditor", (auditorList) => {
      console.log('this.ruleForm.auditUserIdList', auditorList)
      this.ruleForm.auditUserIdList = auditorList
    });
    // getDataMap("AUDIT_SCHEDULE").then((res) => {
    //   if (!res || res.code != 0) return;
    //   // if (this.auditInfo.isBatch) {
    //   this.auditScheduleAttr = res.data.slice(1, 3);
    //   // } else {
    //   //   this.auditScheduleAttr = res.data.slice(1, 4);
    //   // }
    // });
    // if (!this.auditInfo.isBatch) {
    //   userAuditorList(this.auditInfo.deptId).then(({ code, data }) => {
    //     if (code === 0) {
    //       this.memberList = data;
    //     }
    //   });
    // }
  },
};
</script>

<style lang="scss" scoped>
.button-dept {
  margin-left: 10px;
}

.upload_file {
  margin-top: 10px;

  /deep/ .el-upload-dragger {
    height: 90px;
    width: 230px;
  }

  /deep/ .el-upload-dragger .el-icon-upload {
    margin: 0px 0 6px;
    font-size: 40px;
  }
}

.ruleForm {
  margin-top: -10px;
  margin-bottom: -10px;
}
</style>
